import React from 'react';
import cx from 'classnames';

import Text from '../Text';

import { useNavContext } from './NavigationContext';

import styles from './NavigationGroup.module.scss';

export interface NavigationGroupProps {
  /** Should be a `IconButton` that executes an action when clicked. */
  action?: React.ReactNode;
  /** Defines a group of relative `Navigation.Items`.  */
  children?: React.ReactNode;
  /** Apply CSS class to the container. */
  className?: Parameters<typeof cx>[0];
  /** Label for the `Navigation.Group`. */
  label?: string;
}

export const NavigationGroup: React.FC<NavigationGroupProps> = ({
  action,
  children,
  className,
  label,
}) => {
  const { isCollapsed } = useNavContext();

  return (
    <div
      className={cx(
        styles.navGroup,
        isCollapsed && styles.isCollapsed,
        className,
      )}
    >
      {label && (
        <div className={styles.labelGroup}>
          <div>
            <Text
              size={12}
              font='mono'
              weight='bold'
              as='span'
              className={cx(styles.label, isCollapsed && 'visually-hidden')}
              casing='uppercase'
            >
              {label}
            </Text>
          </div>
          {!isCollapsed && <div className={styles.actionWrapper}>{action}</div>}
        </div>
      )}
      <div
        className={cx(
          styles.navItemContainer,
          isCollapsed && styles.isCollapsed,
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default NavigationGroup;
export { styles };
